import React from "react";
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';

SwiperCore.use([Pagination]);

//幻灯片
export default ({
  data, imgStyle, ...customSwiperProps
}) => { // https://stackoverflow.com/questions/36261225
  let swiperProps = {
      ...{spaceBetween:28, slidesPerView:'3', className:'diamond-slider', watchSlidesProgress: true},
      ...customSwiperProps
  }

  return (
          <Swiper
              pagination={{ clickable: true }}
              {...swiperProps}
          >
              {data &&
                  data.length != 0 &&
                  data.map((item, index) => {
                      return (
                          <SwiperSlide key={index + "list"}>
                             <img
                                  onClick={item.onClick || (_ => {})}
                                  src={item.imageURL}
                                  alt={typeof item.alt==='string' ? item.alt : 'Fun88'}
                                  style={typeof imgStyle!=='undefined' ? imgStyle : {
                                    width: "315px",
                                    height: "180px",
                                    verticalAlign: "top",
                                }}
                              />
                          </SwiperSlide>
                      );
                  })}
          </Swiper>
  );
};
